export default function UserJourney() {
  return (
    <section id="how-it-works" className="py-32 px-6 bg-[#050508] relative overflow-hidden">
      {/* Grid background */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute inset-0" style={{
          backgroundImage: `linear-gradient(rgba(0,255,180,0.04) 1px, transparent 1px),
                           linear-gradient(90deg, rgba(0,255,180,0.04) 1px, transparent 1px)`,
          backgroundSize: '60px 60px'
        }}></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 border border-[#00ffb4]/20 bg-[#00ffb4]/5 px-4 py-1.5 rounded-full text-xs font-mono text-[#00ffb4] tracking-widest mb-6">
            EXECUTION PROTOCOL
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">系統運作流程</h2>
          <p className="text-base text-gray-500 max-w-2xl mx-auto">
            三個步驟。五分鐘。一份絕對理性的 PDF 戰略報告。
          </p>
        </div>

        <div className="space-y-0">
          {/* Step 1 */}
          <div className="relative grid md:grid-cols-2 gap-12 items-center pb-20">
            <div className="hidden md:block absolute left-1/2 bottom-0 w-px h-20 bg-gradient-to-b from-[#00ffb4]/30 to-transparent"></div>
            <div>
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 flex items-center justify-center border border-[#00ffb4]/40 rounded-full font-mono text-[#00ffb4] font-bold text-lg">01</div>
                <div className="h-px flex-1 bg-[#00ffb4]/20"></div>
              </div>
              <div className="inline-block border border-[#00ffb4]/30 bg-[#00ffb4]/5 px-3 py-1 rounded-full text-xs font-mono text-[#00ffb4] tracking-widest mb-4">
                OTP 授權
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
                提交 Email<br />獲取單次授權邀請碼
              </h3>
              <p className="text-sm text-gray-400 leading-relaxed mb-6">
                提交您的 Email 申請 Beta 邀請碼。系統將核發一組一次性授權碼（OTP），確保每個分析節點的唯一性與資料完整性。
              </p>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line mt-0.5 flex-shrink-0" style={{ color: '#00ffb4' }}></i>
                  <span className="text-sm text-gray-400">每組邀請碼僅限單次使用，防止資源濫用</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line mt-0.5 flex-shrink-0" style={{ color: '#00ffb4' }}></i>
                  <span className="text-sm text-gray-400">24 小時內發送至您的信箱</span>
                </li>
              </ul>
            </div>
            <div className="bg-[#0a0a0f] border border-[#00ffb4]/15 rounded-lg p-8">
              <div className="font-mono text-xs space-y-3">
                <div className="text-gray-600"># TWINODE AUTH GATEWAY v4.0</div>
                <div className="text-gray-500">&gt; Initializing OTP module...</div>
                <div style={{ color: '#00ffb4' }}>&gt; Email verified: user@domain.com</div>
                <div className="text-gray-500">&gt; Generating one-time token...</div>
                <div style={{ color: '#00d4ff' }}>&gt; TOKEN: TW-BETA-[XXXXXXXX]</div>
                <div style={{ color: '#00ffb4' }}>&gt; Dispatch: SUCCESS ✓</div>
                <div className="text-gray-600 mt-4">// Token expires in 48h</div>
              </div>
            </div>
          </div>

          {/* Step 2 */}
          <div className="relative grid md:grid-cols-2 gap-12 items-center pb-20">
            <div className="hidden md:block absolute left-1/2 bottom-0 w-px h-20 bg-gradient-to-b from-[#00ffb4]/30 to-transparent"></div>
            <div className="bg-[#0a0a0f] border border-[#00d4ff]/15 rounded-lg p-8 order-2 md:order-1">
              <div className="space-y-4">
                <div>
                  <label className="text-xs font-mono text-gray-600 block mb-2">出生日期 / BIRTH DATE</label>
                  <div className="bg-black/50 border border-white/10 rounded-md px-4 py-3 text-sm text-gray-400 font-mono">1990-05-15</div>
                </div>
                <div>
                  <label className="text-xs font-mono text-gray-600 block mb-2">出生時間 / BIRTH TIME</label>
                  <div className="bg-black/50 border border-white/10 rounded-md px-4 py-3 text-sm text-gray-400 font-mono">14:30 CST</div>
                </div>
                <div>
                  <label className="text-xs font-mono text-gray-600 block mb-2">出生地點 / GEO ANCHOR</label>
                  <div className="bg-black/50 border border-white/10 rounded-md px-4 py-3 text-sm text-gray-400 font-mono">台北市, 25.0330°N 121.5654°E</div>
                </div>
                <div>
                  <label className="text-xs font-mono text-gray-600 block mb-2">當前職業向量 / ROLE VECTOR</label>
                  <div className="bg-black/50 border border-white/10 rounded-md px-4 py-3 text-sm text-gray-400 font-mono">SaaS Founder / 創業者</div>
                </div>
              </div>
            </div>
            <div className="order-1 md:order-2">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 flex items-center justify-center border border-[#00d4ff]/40 rounded-full font-mono text-[#00d4ff] font-bold text-lg">02</div>
                <div className="h-px flex-1 bg-[#00d4ff]/20"></div>
              </div>
              <div className="inline-block border border-[#00d4ff]/30 bg-[#00d4ff]/5 px-3 py-1 rounded-full text-xs font-mono text-[#00d4ff] tracking-widest mb-4">
                加密終端機
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
                進入加密終端機<br />輸入底層出廠設定
              </h3>
              <p className="text-sm text-gray-400 leading-relaxed mb-6">
                使用邀請碼進入加密終端機。僅需輸入五大絕對變量：時間錨點、地理錨點與當前職業向量，即可啟動底層多維度碰撞運算。
              </p>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line mt-0.5 flex-shrink-0" style={{ color: '#00d4ff' }}></i>
                  <span className="text-sm text-gray-400">城市級精度地理錨點，四位小數精準定位</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line mt-0.5 flex-shrink-0" style={{ color: '#00d4ff' }}></i>
                  <span className="text-sm text-gray-400">真太陽時校正，消除時區誤差</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Step 3 */}
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 flex items-center justify-center border border-amber-400/40 rounded-full font-mono text-amber-400 font-bold text-lg">03</div>
                <div className="h-px flex-1 bg-amber-400/20"></div>
              </div>
              <div className="inline-block border border-amber-400/30 bg-amber-400/5 px-3 py-1 rounded-full text-xs font-mono text-amber-400 tracking-widest mb-4">
                PDF 戰略交付
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
                系統啟動多維碰撞<br />5 分鐘內 PDF 報告入信箱
              </h3>
              <p className="text-sm text-gray-400 leading-relaxed mb-6">
                Deno 引擎完成確定性核心運算後，GPT-4o 作為結構化編譯器，將硬編碼參數轉譯為包含 6 大矩陣、12 個月高頻預警圖的 PDF 戰略報告，直接發送至您的信箱。
              </p>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line mt-0.5 flex-shrink-0 text-amber-400"></i>
                  <span className="text-sm text-gray-400">6 大戰略矩陣 + 12 個月高頻預警圖</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line mt-0.5 flex-shrink-0 text-amber-400"></i>
                  <span className="text-sm text-gray-400">麥肯錫級結構化語言輸出，零模糊地帶</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line mt-0.5 flex-shrink-0 text-amber-400"></i>
                  <span className="text-sm text-gray-400">PDF 永久存取，終身有效</span>
                </li>
              </ul>
            </div>
            <div className="bg-[#0a0a0f] border border-amber-400/15 rounded-lg p-8">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-8 h-8 flex items-center justify-center bg-amber-400/10 border border-amber-400/30 rounded">
                  <i className="ri-file-pdf-line text-amber-400"></i>
                </div>
                <div>
                  <div className="text-sm font-bold text-white">TWINODE_Report_V4.pdf</div>
                  <div className="text-xs text-gray-600 font-mono">已發送至您的信箱</div>
                </div>
              </div>
              <div className="space-y-3">
                {[
                  { num: '01', label: '底層出廠設定解析', sub: '系統架構分析' },
                  { num: '02', label: '情緒—職業合成矩陣', sub: '認知盲點識別' },
                  { num: '03', label: '歷史周期驗證', sub: '宏觀摩擦分析' },
                  { num: '04', label: '2026 環境變量碰撞', sub: '時空概率收斂' },
                  { num: '05', label: '流動性防禦協議', sub: '風險對沖策略' },
                  { num: '06', label: '12 個月高頻預警圖', sub: '戰術行動協議' },
                ].map((item) => (
                  <div key={item.num} className="flex items-center gap-4 bg-black/30 border border-white/5 rounded-md px-4 py-3">
                    <span className="text-xs font-mono text-gray-600">{item.num}</span>
                    <div>
                      <div className="text-xs font-bold text-white">{item.label}</div>
                      <div className="text-xs text-gray-600">{item.sub}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
